"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniProductQuickIconsFeature = OmniProductQuickIconsFeature;
const feature_consensus_1 = require("@branch-ts/feature-consensus");
const web_consensus_1 = require("@branch-ts/web-consensus");
const verset_consensus_1 = require("@project/verset_consensus");
const EnableGuildIcon = feature_consensus_1.FeatureMechanism.declare("@project/verset_webapp", "EnableGuildIcon", { enabled: false });
const EnableNotificationIcon = feature_consensus_1.FeatureMechanism.declare("@project/verset_webapp", "EnableNotificationIcon", { enabled: false });
function OmniProductQuickIconsFeature(config) {
    const features = feature_consensus_1.FeatureMechanism.package("@project/verset_webapp");
    // Notification support stays initialized; only its button is opt-in.
    features.if(EnableNotificationIcon.featureName, () => {
        config.omniBar.notificationSupport.registerQuickIcon();
    });
    config.omniBar.quickIcons.register({
        id: "profile",
        icon: "omni-profile",
        title: "Profile",
        onActivate: () => {
            window.open("/dashboard/profile", "_blank", "noopener");
        },
    });
    features.if(EnableGuildIcon.featureName, () => {
        config.omniBar.quickIcons.register({
            id: "guild",
            icon: "omni-guild",
            title: `My ${verset_consensus_1.VersetProtocol.ProductName.guild}`,
            order: 30,
            onActivate: () => {
                web_consensus_1.UIMechanism.goto({
                    uri: "/guild/my",
                });
            },
        });
    });
}
